import { AutocompletePlaces } from "@inputs/autocomplete/AutocompletePlacesUniq";
import { Chip, TextField, autocompleteClasses } from "@mui/material";
import { type Control, Controller } from "react-hook-form";
import type { TModalSocialOfferFormResolver } from "../logics/resolver";

interface IModalSocialOfferFormFieldPerimeter {
  control: Control<TModalSocialOfferFormResolver>;
}

export const ModalSocialOfferFormFieldPerimeter = ({ control }: IModalSocialOfferFormFieldPerimeter) => {
  return (
    <Controller
      control={control}
      name="perimeter"
      render={({ field: { value, onChange }, fieldState: { error }, formState: { errors } }) => (
        <AutocompletePlaces
          multiple
          value={value}
          onChange={(_, value) => onChange(value)}
          fullWidth
          size="small"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Offre ouverte aux habitants de"
              size="small"
              error={!!error}
              helperText={error?.message ?? errors?.perimeter?.message}
            />
          )}
          renderValue={(values, getTagProps) =>
            values.map((value, index) => (
              <Chip
                color="yellow"
                label={value.placeLabel}
                size="small"
                sx={{ [`&.${autocompleteClasses.tag}`]: { mt: "1px", mb: 0 } }}
                {...getTagProps({ index })}
                key={value._id}
              />
            ))
          }
          limitTags={3}
        />
      )}
    />
  );
};
